
export { useGetRelatedProductsCategory } from "./hooks"